export default __webpack_public_path__ + "static/media/tarsIcon.d7e30d75.png";